import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CrudOperation } from '@shared/models';
import { AppNotificationService } from '@shared/services';
import { QueryOptions } from 'odata-query';
import {
  Collection,
  GridItemCreateEvent,
  ResidencyJurisdiction,
} from '../../models';
import { ResidencyJurisdictionService } from '../../services';

@Component({
  standalone: false,
  selector: 'gstar-residency-jurisdictions-page',
  templateUrl: 'residency-jurisdictions-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResidencyJurisdictionsPageComponent {
  private readonly residencyJurisdictionService = inject(
    ResidencyJurisdictionService
  );
  private readonly appNotificationService = inject(AppNotificationService);
  private readonly translateService = inject(TranslateService);

  public residencyJurisdiction: WritableSignal<
    Collection<ResidencyJurisdiction>
  > = signal({
    total: 0,
    items: [],
  });

  public query: Partial<QueryOptions<ResidencyJurisdiction>> = {};

  private residencyJurisdictionsTitle = this.translateService.instant(
    'admin.dashboard.residencyJurisdictionsTitle'
  );

  create(
    residencyJurisdictionGridItem: GridItemCreateEvent<ResidencyJurisdiction>
  ): void {
    let isSuccess = false;

    this.residencyJurisdictionService
      .create(residencyJurisdictionGridItem.item)
      .subscribe(() => {
        residencyJurisdictionGridItem.onSuccess();
        isSuccess = true;

        this.fetchResidencyJurisdictions();

        this.appNotificationService.crudNotify(
          CrudOperation.Create,
          this.residencyJurisdictionsTitle,
          isSuccess
        );
      });
  }

  update(
    residencyJurisdictionGridItem: GridItemCreateEvent<ResidencyJurisdiction>
  ): void {
    let isSuccess = false;

    this.residencyJurisdictionService
      .update(residencyJurisdictionGridItem.item)
      .subscribe(() => {
        residencyJurisdictionGridItem.onSuccess();
        isSuccess = true;
        this.fetchResidencyJurisdictions();

        this.appNotificationService.crudNotify(
          CrudOperation.Update,
          this.residencyJurisdictionsTitle,
          isSuccess
        );
      });
  }

  queryUpdate(
    residencyJurisdictionQuery: Partial<QueryOptions<ResidencyJurisdiction>>
  ): void {
    this.query = residencyJurisdictionQuery;
    this.fetchResidencyJurisdictions();
  }

  private fetchResidencyJurisdictions(): void {
    this.residencyJurisdictionService
      .get({ ...this.query, count: true })
      .subscribe(
        (
          residencyJurisdictionCollection: Collection<ResidencyJurisdiction>
        ) => {
          this.residencyJurisdiction.set(residencyJurisdictionCollection);
        }
      );
  }
}
